<template>
	<BaseWebshopPriorityOrder v-slot="{onSubmit, loading, isActive}">
		<div class="priority-order" :class="[{'loading': loading}, mode]">
			<input type="checkbox" id="field-priority" :checked="isActive" @click.prevent="onSubmit">
			<BaseCmsLabel for="field-priority" code="priority_order" tag="label" />
			<div v-if="loading" />
		</div>
	</BaseWebshopPriorityOrder>
</template>

<script setup>
	const props = defineProps(['mode']);
</script>

<style lang="less" scoped>
	.priority-order{
		padding: 30px 30px 30px 150px; border: 5px solid #D4C9DE; position: relative; font-weight: 300; border-radius: 2px;
		&:before{.pseudo(auto,auto); .icon-priority; font: 80px/80px var(--fonti); color: var(--primaryColor); left: 38px;}
		:deep(strong){
			display: block; margin-bottom: 8px;
			span{color: var(--primaryColor);}
		}
		:deep(p){padding-bottom: 0;}
		input[type=checkbox]+label{font-size: 18px; line-height: 24px; padding: 3px 0 0 34px;}
		&.active{border-color: var(--primaryColor);}

		@media (max-width: @l){
			padding: 25px 25px 25px 115px;
			&:before{font: 72px/72px var(--fonti); left: 25px;}
		}
		@media (max-width: @t){
			padding: 20px 20px 20px 115px;
			&:before{font: 66px/66px var(--fonti); left: 25px; top: 24px;}
			input[type=checkbox]+label{padding-left: 32px; font-size: 16px; line-height: 22px;}
			:deep(p){font-size: 16px; line-height: 22px; padding-bottom: 0;}
		}
		@media (max-width: @m){
			border-left: unset; border-right: unset; padding: 15px; border-radius: unset;
			&:before{display: none;}
			input[type=checkbox]+label{
				font-size: 16px; line-height: 20px; padding-left: 30px;
				:deep(strong){font-size: 18px; line-height: 20px; margin-bottom: 5px;}
				:deep(p){display: inline-block; font-size: 16px; line-height: 20px;}
			}
		}
	}


	//CHECKOUT
	.priority-order-checkout{
		padding: 22px 22px 22px 105px; margin-bottom: 20px;
		&:before{font: 60px/60px var(--fonti); left: 22px; top: 24px;}
		:deep(strong){font-size: 18px; line-height: 24px; margin-bottom: 6px;}
		input[type=checkbox]+label{font-size: 16px; line-height: 22px; font-weight: 300;}
		:deep(span){display: block;}
		@media (max-width: @l){
			padding: 25px 25px 25px 115px;
			&:before{font: 72px/72px var(--fonti); left: 25px;}
		}
		@media (max-width: @t){
			padding: 20px 20px 20px 82px;
			&:before{left: 16px; top: 24px; font: 46px/46px var(--fonti);}
			:deep(strong){
				font-size: 16px; line-height: 22px; margin-bottom: 5px;
				span{display: block;}
			}
			input[type=checkbox]+label{font-size: 15px; line-height: 21px;}
			:deep(p){font-size: 15px; line-height: 21px;}
		}
		@media (max-width: @tp){
			padding: 15px;
			&:before{display: none;}
			:deep(strong){
				font-size: 16px; line-height: 20px; margin-bottom: 5px;
				span{display: block;}
			}
			input[type=checkbox]+label{font-size: 14px; line-height: 19px; font-weight: normal;}
			:deep(p){font-size: 14px; line-height: 19px; font-weight: normal;}
		}
		@media (max-width: @m){
			margin-top: -1px; margin-bottom: 0;
			:deep(strong){
				span{display: inline-block;}
			}
			input[type=checkbox]+label{
				font-size: 13px; line-height: 18px;
				:deep(p){font-size: 13px; line-height: 18px;}
			}
		}
	}
</style>
